import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './SupportModals.css'; // Ortak stil dosyası kullanacağız

const CustomerInfoModal = ({ isOpen, onClose, customer }) => {
  const { t } = useTranslation();

  if (!isOpen || !customer) return null;

  return ReactDOM.createPortal(
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>{t('customer_details', 'Müşteri Detayları')}</h3>
          <button onClick={onClose} className="close-btn">&times;</button>
        </div>
        <div className="info-modal-body">
          <div className="info-row"><span>{t('full_name')}</span><strong>{customer.first_name} {customer.last_name}</strong></div>
          <div className="info-row"><span>{t('email_address')}</span><strong>{customer.email}</strong></div>
          <div className="info-row"><span>{t('phone')}</span><strong>({customer.phone_country_code}) {customer.phone_number}</strong></div>
          <div className="info-row"><span>{t('total_orders', 'Toplam Sipariş')}</span><strong>{customer.total_orders}</strong></div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default CustomerInfoModal;